<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="6" sm="4" md="2">
        <v-dialog
          v-model="poiMarkersDialog"
          max-width="80%"
        >
          <template v-slot:activator="{on, attrs}">
            <v-btn
              color="primary"
              v-bind="attrs"
              v-on="on"
              small
            >
              Google map
            </v-btn>
          </template>
            <v-card>
              <v-card-title></v-card-title>
              <v-card-text>
                <GoogleMapMarkers
                  :items="googleMapPoiList"
                  :isVisible="poiMarkersDialog"
                />
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="blue darken-1"
                  text
                  @click="poiMarkersDialog=false"
                >
                  Ok
                </v-btn>
              </v-card-actions>
            </v-card>
        </v-dialog>
      </v-col>
      <v-col cols="6" sm="4" md="2">
        <v-select
          v-model="sort"
          :items="sortList"
          label="Sort by"
          dense
          outlined
          @change="sortPoi"
          hide-details
        ></v-select>
      </v-col>
    </v-row>

    <div class="text-center">
      <v-btn
          v-for="(title, label) in filterOptions"
          :key="label"
          class="my-2 mx-1"
          :color="filterPoi === label ? 'primary': ''"
          small
          @click="filterPoi = label"
      >{{ label }}</v-btn>
      <v-autocomplete
        v-model="filterGeotag"
        :items="geotags"
        item-text="name"
        item-value="id"
        label="geotags"
        class="geotag-select my-2 mx-1"
        outlined
        clearable
        multiple
        dense
        chips
        small-chips
        deletable-chips
        hide-details
        @focus="getGeotagsList()"
        :loading="isLoadingGeotags"
        :no-data-text="isLoadingGeotags ? 'loading...' : 'No data available'"
        :filter="nonDiacriticsSensitiveFilter"
        :menu-props="{ closeOnContentClick: true }"
      >
        <template v-slot:item="{ item }">
          {{ item.name }} - {{ item.country }}
        </template>
      </v-autocomplete>
    </div>

    <v-card
        v-for="poiRel in pois"
        :key="poiRel.id"
        class="mb-5"
        :class="![$constants.POI_STATUSES.NEW, $constants.POI_STATUSES.IN_REVIEW].includes(poiRel.status)  ? 'disable_block' : ''"
        v-show="showPoi(poiRel)"
    >
      <router-link :to="`/poi/${poiRel.id}`" class="text-decoration-none black--text">
        <v-card-title>
          {{ poiRel.poi?.name }} ({{ poiRel.poi?.geotags.map((el) => el.name).join(', ') }})
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              <v-icon :color="poiRel.videos_count ? 'green' : ''">mdi-video</v-icon>
              Video count:
              {{ poiRel.videos_count }}
            </v-col>
            <v-col cols="4">
              Comments:
              <span :class="poiRel.videos_with_new_comments_count ? 'red--text' : ''">{{ poiRel.videos_with_comments_count }}</span>
            </v-col>
            <v-col cols="2">
              <status-icon :status="poiRel.status" :count-video="poiRel.videos_count"></status-icon>
            </v-col>
          </v-row>
          <span class="d-flex align-center mt-2" v-if="poiRel.payment_status">
            <v-tooltip bottom :disabled="!poiRel.payment_date">
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">
                  <v-icon>mdi-currency-usd</v-icon>
                  {{ $constants.PAYMENTS_STATUSES[poiRel.payment_status] }}
                </span>
              </template>
              <span>{{ poiRel.payment_date }}</span>
            </v-tooltip>
          </span>
        </v-card-text>
      </router-link>
    </v-card>
  </v-container>
</template>

<script>
import StatusIcon from "@/components/StatusIcon";
import GoogleMapMarkers from "@/components/GoogleMapMarkers.vue";
export default {
  name: 'MyPoisView',
  components: {GoogleMapMarkers, StatusIcon},
  mounted() {
    this.localOptions()

    this.getUserPois()
  },
  data() {
    return {
      pois: [],
      sort: 'status',
      sortList: ['A-Z', 'Z-A', 'status'],
      filterOptions: {
        'All': 'All assigned Points Of Interest',
        'New': 'Assigned, no videos have been uploaded',
        'In Progress': 'Point Of Interest is being worked on',
        'In Review': 'Your videos are being reviewed by TripBits Team',
        'Done': 'Your videos have been accepted'
      },
      filterPoi: 'All',
      poiMarkersDialog: false,
      geotags: [],
      isLoadingGeotags: false,
      filterGeotag: [],
    }
  },
  methods: {
    getUserPois() {
      this.$requestHelpers.get('/api/ambassador/pois')
        .then((data) => {
          this.pois = data
          this.sortPoi()
        })
    },

    getGeotagsList() {
      // skip if the list is already received
      if (this.geotags.length > 0) return;

      this.isLoadingGeotags = true;
      this.$requestHelpers.post(
        '/api/ambassador/geotags/geotagsList', {}, {
          withOverlay: false,
        },
      ).then((data) => {
        this.geotags = data;
      }).finally(() => { this.isLoadingGeotags = false; });
    },

    showPoi: function (poiRel) {
      if (this.filterGeotag.length) {
          if (!poiRel.poi.geotags.filter(el => this.filterGeotag.some(gId => el.id === gId)).length) {
              return false
          }
      }

      if (this.filterPoi === 'All') {
        return true
      }

      switch (poiRel.status) {
        case this.$constants.POI_STATUSES.NEW:
          if (this.filterPoi === 'In Progress' && poiRel.videos_count) {
            return true
          }

          if (this.filterPoi === 'New' && !poiRel.videos_count) {
            return true
          }
          break;
        case this.$constants.POI_STATUSES.IN_REVIEW:
          if (this.filterPoi === 'In Review') {
              return true
          }
          break;
        default:
          if (this.filterPoi === 'Done') {
              return true
          }
      }

      return false
    },

    sortPoi: function () {
      this.pois.sort((a, b) => {
        switch (this.sort) {
          case 'A-Z':
            if (a.poi.name < b.poi.name) { return -1; }
            if (a.poi.name > b.poi.name) { return 1; }
            return 0;
          case 'Z-A':
            if (a.poi.name < b.poi.name) { return 1; }
            if (a.poi.name > b.poi.name) { return -1; }
            return 0;
          case 'status':
          default:
            if (a.status === b.status) {
              return b.videos_count - a.videos_count;
            } else {
              return a.status - b.status;
            }
        }
      })
    },

    localOptions() {
      if (localStorage.poi_sort) {
        this.sort = localStorage.poi_sort;
      }
      if (localStorage.poi_filter) {
        this.filterPoi = localStorage.poi_filter;
      }
      if (localStorage.geotag_filter) {
        this.filterGeotag = JSON.parse(localStorage.geotag_filter);
      }
    },
  },
  watch:{
    sort: function(newValue) {
      if (newValue) {
        localStorage.poi_sort = newValue;
      }
    },
    filterPoi: function(newValue) {
      if (newValue) {
        localStorage.poi_filter = newValue;
      }
    },
    filterGeotag: function(newValue) {
      if (newValue && newValue.length > 0) {
        this.getGeotagsList();
      }
      localStorage.geotag_filter = JSON.stringify(newValue);
    },
  },
  computed:{
    googleMapPoiList() {
      return this.pois.filter(el => this.showPoi(el)).map(el => el.poi)
    }
  },
}
</script>

<style scoped>
.disable_block {
  opacity: 0.4;
  background: #ccc;
}
.geotag-select {
    display: inline-flex;
    vertical-align: middle;
}
</style>
